import styled, { css } from "styled-components";
import { HOVER_TRANSITION } from "../../constants/design/motion";
import { SideResponse } from "../../codegen-api";
import {
  COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS, FONT_SIZE } from "../../constants/design/fontSize";
import {
  BORDER_RADIUS,
  COMPONENTS,
  SPACING,
} from "../../constants/design/spacing";
import { sideColors } from "../../utils/sideColors";
import { frostedGlassBg } from "../shared/style";

export const SubmitWrapper = styled.div<{ isSticky?: boolean }>`
  padding: ${SPACING.three}px;

  ${({ isSticky }) =>
    isSticky
      ? css`
          position: sticky;
          bottom: 0;
          padding: ${SPACING.three}px;
          z-index: 3;
          ${frostedGlassBg("rgba(18, 18, 26, 0.36)", LAYER_COLORS.one, 8)}
        `
      : css``}
`;

export const SubmitButton = styled.button`
  justify-content: center;
  ${HOVER_TRANSITION}
  display: flex;
  width: 100%;
  border-radius: ${BORDER_RADIUS.two}px;
  color: ${TEXT_COLORS.two};
  font-size: ${FONT_SIZE.two};
  padding: ${SPACING.three}px ${SPACING.two}px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

export const PlaceOrderButton = styled(SubmitButton)<{ side: SideResponse }>`
  background-color: ${({ side }) => sideColors(side).one};
  color: ${({ side }) => sideColors(side).on};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  margin-bottom: ${SPACING.three}px;
  font-weight: 600;

  /* The primary action of the whole product had NO hover state. It declared a
     transition and then defined nothing to transition to, so the most-clicked
     control in the app gave no feedback at all before committing a trade.
     Brightness rather than a second colour: the buy/sell colour is
     user-configurable, so any hardcoded hover colour would fight the setting. */
  &:hover:not(:disabled) {
    filter: brightness(1.12);
  }

  &:active:not(:disabled) {
    filter: brightness(0.94);
  }
`;

export const ClosePositionButton = styled(SubmitButton)`
  font-size: ${FONT_SIZE.one};
  padding: 0;
`;

export const TotalFilledBarContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TotalFillSize = styled.span`
  color: ${TEXT_COLORS.three};
  &:before {
    content: " ";
  }
`;

export const OrderbookTabWrapper = styled.div<{ isMobile?: boolean }>`
  position: relative;
  overflow: scroll;
  height: ${({ isMobile }) =>
    isMobile ? "100vh" : `${COMPONENTS.tradeTicketOrderbookHeight}px`};
`;

export const OrderbookEmptyContent = styled.div`
  display: flex;
  height: 100%;
  text-align: center;
`;

export const PlaceholderContent = styled.div`
  color: ${TEXT_COLORS.three};
  display: flex;
  min-height: 320px;
  align-items: center;
  justify-content: center;
  font-size: ${FONT_SIZE.two};
`;

export const LiquidationsText = styled.div`
  color: ${COLORS.negative.one};
  ${FONT_CSS.body.five};
  text-align: center;
  padding: ${SPACING.three}px ${SPACING.two}px;
`;

export const DeselectReduceOnlyContainer = styled.div<{ show: boolean }>`
  overflow: hidden;
  background-color: ${LAYER_COLORS.two};
  padding: ${SPACING.two}px;
  border-radius: ${BORDER_RADIUS.two}px;

  div:nth-child(1) {
    ${FONT_CSS.label.two}
    color: ${COLORS.highlight.one};
  }

  div:nth-child(2) {
    ${FONT_CSS.label.three}
    color: ${TEXT_COLORS.two};
    strong {
      color: ${TEXT_COLORS.one};
    }
  }

  transition: all 0.2s ease-in-out;

  ${({ show }) =>
    show
      ? css`
          opacity: 1;
          height: 80px;
        `
      : css`
          opacity: 0;
          height: 0px;
          padding: 0;
          pointer-events: none;
        `}
`;

export const CheckboxContainer = styled.div`
  padding-top: ${SPACING.two}px;
`;
